export default __webpack_public_path__ + "static/media/radio-select-vs-radio-prefer.17ef5b3b.svg";